import requests from "./httpService";

const reviewsService = {
  createReview(body) {
    return requests.post("/reviews/add", body);
  },
};

export default reviewsService;
